import React from 'react';

export interface SectionLabelProps {
  children: React.ReactNode;
  className?: string;
  /** Bottom padding variant. Default is 'sm' (pb-1). Use 'md' for pb-3 (before grid content). */
  spacing?: 'none' | 'sm' | 'md';
}

const SPACING: Record<'none' | 'sm' | 'md', string> = {
  none: '',
  sm: 'pb-1',
  md: 'pb-3',
};

export function SectionLabel({ children, className, spacing = 'sm' }: SectionLabelProps) {
  return (
    <div
      className={[
        'text-[11px] font-semibold uppercase tracking-[0.05em] text-text-tertiary',
        SPACING[spacing],
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}
